import React from 'react';
import type { FuzzySearchMatch } from '../utils/search/fuzzySearch';

interface LocalSearchHighlightProps {
  matchKey: string;
  refIndex?: number;
  matches?: readonly FuzzySearchMatch[];
  defaultValue?: React.ReactNode;
}

const LocalSearchHighlight = ({
  matchKey,
  refIndex,
  matches = [],
  defaultValue,
}: LocalSearchHighlightProps) => {
  const match = matches.find(
    (m) =>
      m.key === matchKey && (refIndex === undefined || m.refIndex === refIndex),
  );

  if (!match?.value) return <>{defaultValue}</>;

  const { value, indices } = match;
  const highlighted = [];
  let index = 0;

  indices.forEach(([start, end]) => {
    const before = value.slice(index, start);
    const matched = value.slice(start, end + 1);

    highlighted.push(before);
    highlighted.push(<strong key={`${start}_${end}`}>{matched}</strong>);
    index = end + 1;
  });

  highlighted.push(value.slice(index));

  return <>{highlighted}</>;
};

export default LocalSearchHighlight;
